import React, { ReactNode, useContext, useEffect } from "react";
import Wrapper from "../components/Wrapper";
import Sidebar from "../components/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/Navbar/Navbar";
import Content from "../components/Content";

type DashboardProps = {
  children: ReactNode;
  scrollableContent?: boolean;
  disableContentPadding?: boolean;
};

const Dashboard = ({
  children,
  scrollableContent,
  disableContentPadding,
}: DashboardProps) => {
  useEffect(() => {
    let bodyOverflow: string;
    if (scrollableContent) {
      const body = document.body;
      bodyOverflow = body.style.overflow;
      body.style.overflow = "hidden";
    }
    return () => {
      if (scrollableContent) {
        const body = document.body;
        body.style.overflow = bodyOverflow;
      }
    };
  }, [scrollableContent]);

  return (
    <React.Fragment>
      <Wrapper>
        <Sidebar />
        <Main>
          <Navbar />
          <Content
            flex
            scrollableContent={scrollableContent}
            disableContentPadding={disableContentPadding}
          >
            {children}
          </Content>
        </Main>
      </Wrapper>
    </React.Fragment>
  );
};

export default Dashboard;
